export default "__VITE_ASSET__CPdIA85s__"